export default () => ({
    activeIndex: Alpine.$persist(0).as('banner_active_index_' + window.location.pathname),
    totalCount: 0,
    displayCounts: [],
    activeDisplayCount: 0,
    activeDisplayCountLeft: Alpine.$persist(0).as('banner_views_left_' + window.location.pathname),
    init() {
        // noinspection JSUnresolvedReference
        this.totalCount = parseInt(this.$root.dataset.count);
        // noinspection JSUnresolvedReference
        this.displayCounts = this.$root.dataset.displayCounts.split(',').map(Number);
        this.activeDisplayCount = this.displayCounts[this.activeIndex] ?? 0;
        this.updateDisplayCountLeft();
        this.updateCurrentIndex();
    },
    updateCurrentIndex(){
        if(this.totalCount < this.activeIndex + 1){
            this.activeIndex = 0;
        }
        if(this.activeDisplayCountLeft){
            return;
        }
        if (this.activeIndex < this.totalCount - 1) {
            this.activeIndex++;
        } else {
            this.activeIndex = 0;
        }
    },
    updateDisplayCountLeft(){
        if(this.activeDisplayCountLeft <= 0){
            this.activeDisplayCountLeft = this.activeDisplayCount;
        }
        else {
            this.activeDisplayCountLeft--;
        }
    }
});